/* globals d3 */
angular.module('zc.zenclerkS')

  .component('zcsUserActivityGraph', {
    templateUrl: '/templates/zenclerk_s/directives/project_user_activity/user_activity_graph.html',
    bindings: {
      project: '<'
    },
    controllerAs: 'vm',
    controller: function($translate, $element, $scope, $window, Campaign, MongoSession) {
      const DAYS = 30;
      const LINE_HEIGHT = 30;
      const MARGINY = 5;
      const WEEKDAYS = [
        $translate.instant('directives.common.weekday.sunday'),
        $translate.instant('directives.common.weekday.monday'),
        $translate.instant('directives.common.weekday.tuesday'),
        $translate.instant('directives.common.weekday.wednesday'),
        $translate.instant('directives.common.weekday.thursday'),
        $translate.instant('directives.common.weekday.friday'),
        $translate.instant('directives.common.weekday.saturday')
      ];

      let vm = this;

      let svg;
      let xScale, yScale, yScaleCampaign, color, campaignColor;
      let margin = {top: 20, right: 20, bottom: 30, left: 20};
      let width = 300 - margin.left - margin.right;
      let height = LINE_HEIGHT * 2 + 20 - margin.top - margin.bottom;

      this.$onInit = () => {
        svg = d3.select($element.find('svg')[0]);

        Campaign.all({projectId: vm.project.id}).then(campaigns => {
          vm.project.campaigns = _.filter(campaigns, d => d.start_at && d.end_at && d.current_status !== 'unfinished');
          createGraph();
        });

        $scope.$on('gotSessions', (event, project) => {
          if(project.id === vm.project.id) createGraph();
        });

        // listen resize for redrawing
        let w = angular.element($window);
        w.bind('resize', createGraph);
      };

      function addOuterBox(group) {
        group.append('rect')
          .attr('x', 0)
          .attr('y', MARGINY)
          .attr('width', width)
          .attr('height', LINE_HEIGHT)
          .style('stroke-width', 1)
          .style('stroke', 'rgba(0,0,0,1)')
          .style('fill', 'rgba(255,255,255,0.2)')
          .style('pointer-events', 'stroke');
      }

      function addTextLabels(group) {
        group.append('text')
          .attr('x', 0)
          .attr('y', LINE_HEIGHT + 20)
          .style('font-size', '12px')
          .text(d => $translate.instant('directives.common.daysAgo', { day: DAYS }));

        group.append('text')
          .attr('x', width - 8)
          .attr('y', LINE_HEIGHT + 20)
          .style('font-size', '12px')
          .text(d => $translate.instant('directives.common.now'));
      }

      function addSession(group) {
        group.append('rect')
          .attr('class', 'session')
          .attr('y', MARGINY)
          .attr('x', d => xScale(d.opened_at.valueOf()))
          .attr('width', d => {
            if(!d.closed_at) return 3;
            let val = xScale(d.closed_at.valueOf()) - xScale(d.opened_at.valueOf());
            if(val < 3) val = 3;
            return val;
          })
          .attr('height', LINE_HEIGHT)
          .style('opacity', 0.5)
          .style('fill', d => color(d))
          .call(setupUserTooltip);
      }

      function addCampaigns(group) {
        group.append('rect')
          .attr('class', 'campaign')
          .attr('y', d => yScaleCampaign(d.id))
          .attr('x', d => xScale(d.start_at.valueOf()))
          .attr('width', d => {
            let val = xScale(d.end_at.valueOf()) - xScale(d.start_at.valueOf());
            let max = width - xScale(d.start_at.valueOf());
            if(val > max) val = max;
            return val;
          })
          .attr('height', d => (LINE_HEIGHT - MARGINY) / vm.project.campaigns.length)
          .style('fill', d => campaignColor(d.id))
          .call(setupCampaignTooltip);
      }

      function createScales() {
        color = d3.scale.category20b().domain(vm.project.users);
        campaignColor = d3.scale.category20c().domain(vm.project.campaigns);

        xScale = d3.scale.linear()
          .domain([moment().subtract(DAYS, 'days').valueOf(), moment().valueOf()])
          .range([0, width]);

        yScale = d3.scale.ordinal()
          .domain(_.map(vm.project.users, u => u.id))
          .range([MARGINY, LINE_HEIGHT]);

        yScaleCampaign = d3.scale.ordinal()
          .domain(_.map(vm.project.campaigns, c => c.id))
          .rangePoints([MARGINY, LINE_HEIGHT - 3]);
      }

      function getUserById(id) {
        return _.filter(vm.project.users, user => user.id === id)[0];
      }

      function hideTooltip(d, i) {
        let tooltip = $element.find('.activity-graph-tooltip');
        // TODO: fix
        //tooltip.css('display', 'none');
        tooltip.css('visibility', 'hidden');
      }

      function moveTooltip(d, i) {
        let tooltip = $element.find('.activity-graph-tooltip');
        tooltip.css('left', (d3.event.pageX - 100) + 'px');
        tooltip.css('top', (d3.event.pageY - 50) + 'px');
      }

      function showUserTooltip(d, i) {
        if(!d._id) return hideTooltip();

        let tooltip = $element.find('.activity-graph-tooltip');
        let user = getUserById(parseInt(d.cookie_segment.user_id));

        if(!user) return hideTooltip();

        let tooltipText = tooltip.find('.activity-graph-tooltip-text');
        tooltipText.html(`
        <div></div>
        <div>
          ${moment(d.opened_at).format('YYYY-MM-DD HH:mm')} 
          (${WEEKDAYS[moment(d.opened_at).day()]})
        </div>
        <div>
          ${moment(d.closed_at).format('YYYY-MM-DD HH:mm')}
          (${WEEKDAYS[moment(d.closed_at).day()]})
        </div>
      `);
        // names are set by project users, so set them as text, not HTML
        tooltipText.children().first().text(user.full_name);
        // TODO: fix
        //tooltip.css('display', 'block');
        tooltip.css('visibility', 'visible');
      }

      function showCampaignTooltip(d, i) {
        let tooltip = $element.find('.activity-graph-tooltip');
        let tooltipText = tooltip.find('.activity-graph-tooltip-text');
        tooltipText.html(`
        <div></div>
        <div>
          ${moment(d.start_at).format('YYYY-MM-DD HH:mm')}
          (${WEEKDAYS[moment(d.start_at).day()]})
        </div>
        <div>
          ${moment(d.end_at).format('YYYY-MM-DD HH:mm')}
          (${WEEKDAYS[moment(d.end_at).day()]})
        </div>
      `);
        // names are set by project users, so set them as text, not HTML
        tooltipText.children().first().text(d.name);
        // TODO: fix
        //tooltip.css('display', 'block');
        tooltip.css('visibility', 'visible');
      }

      function setupCampaignTooltip(group) {
        group
          .on('mouseenter', showCampaignTooltip)
          .on('mousemove', moveTooltip)
          .on('mouseleave', hideTooltip);
      }

      function setupUserTooltip(group) {
        group
          .on('mouseenter', showUserTooltip)
          .on('mousemove', moveTooltip)
          .on('mouseleave', hideTooltip);
      }

      function addWeekends(group) {
        let startTime = moment().subtract(DAYS, 'days').toDate();
        let weekends = [];
        for(let i = 0; i < DAYS; i++) {
          let day = moment(startTime).add(i, 'days');
          let dayOfWeek = day.day();
          // sunday or saturday
          if(dayOfWeek === 0 || dayOfWeek === 6) {
            weekends.push(day.toDate());
          }
        }

        group.selectAll('.weekend')
          .data(weekends)
          .enter()
          .append('rect')
          .attr('class', 'weekend')
          .attr('x', d => xScale(moment(d).valueOf()))
          .attr('y', MARGINY)
          .attr('width', d => {
            const oneDayLater = moment(d).add(1, 'days').valueOf();
            const now = moment(d).valueOf();
            return xScale(oneDayLater) - xScale(now);
          })
          .attr('height', LINE_HEIGHT)
          .style('stroke-width', 1)
          .style('stroke', 'rgba(0,0,0,0.2)')
          .style('fill', 'rgba(255,128,0,0.1)')
          .style('pointer-events', 'stroke');
      }

      function createGraph() {
        if(!vm.project.campaigns) vm.project.campaigns = [];

        // update width
        width = $element.parent().width() - margin.left - margin.right;

        svg
          .attr('width', width + margin.left + margin.right)
          .attr('height', height + margin.top + margin.bottom)
          .append('g')
          .attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');

        let sessions = _.chain(vm.project.users)
          .filter(user => user.sessions)
          .map(user => user.sessions)
          .flatten()
          .filter(session => session.opened_at)
          .value();

        createScales();

        svg.selectAll('*').remove();

        let projectGrp = svg.selectAll('.project-group')
          .data(vm.project.users)
          .enter()
          .append('g')
          .attr('y', d => yScale(d.id))
          .attr('class', 'project-group');

        let campaignGrp = svg.selectAll('.campaign-group')
          .data(vm.project.campaigns)
          .enter()
          .append('g')
          .attr('y', LINE_HEIGHT)
          .attr('class', 'campaign-group');

        campaignGrp
          .call(addCampaigns);

        projectGrp
          .call(addTextLabels);

        svg.call(addWeekends);
        svg.call(addOuterBox);

        svg.selectAll('.session')
          .data(sessions)
          .enter()
          .append('g')
          .attr('y', d => yScale(d))
          .call(addSession);
      }
    }
  });




// WEBPACK FOOTER //
// ./src/zenclerk_s_modules/zenclerk_s/directives/project_user_activity/user_activity_graph.directive.js